// extracted by mini-css-extract-plugin
export default {"container":"function-detail-toolbar_container__GjhBK"};